import React from 'react';
import { ImageListing } from '@redturtle/iovisit-theme/components';

const SliderImage = (props) => {
  return <ImageListing {...props} />;
};

export default SliderImage;
